import { useLocation, useParams } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import HeroSlider from "../../wrappers/HeroSlider";
import { Container } from "react-bootstrap";
import { useState } from "react";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import { usePartner } from "../../helpers/BrandPageAPI";

const inputFields = [
    { name: "FullName", placeholder: "Full Name", type: "text" },
    { name: "CompanyName", placeholder: "Company Name", type: "text" },
    { name: "MobileNo", placeholder: "Mobile Number", type: "text" },
    { name: "Email", placeholder: "Email ID", type: "email" },
];

const initialState = {
    FullName: "",
    CompanyName: "",
    MobileNo: "",
    Email: "",
    Description: "",
};

const Connect_Us = () => {
    const { partnerData } = usePartner();
    const customerCodeStore = useParams();
    const customerCode = customerCodeStore?.UserCode;
    let { pathname } = useLocation();
    const [loading, setLoading] = useState(false);

    return (
        <>
            {loading && <LoadingSpinner />}
            <SEO titleTemplate="Contact" description="Contact page" />
            <LayoutTwo>
                <HeroSlider />
                <Container>
                    <Breadcrumb
                        pages={[
                            { label: "Home", path: `/${customerCode}` },
                            { label: "Connect Us", path: pathname },
                        ]}
                    />
                    <div className="contact-area pb-100 pt-50">
                        <div className="container">
                            <div className="custom-row-2">
                                <div className="col-12 col-lg-5 col-md-5">
                                    <div className="contact-info-wrap">
                                        <div className="single-contact-info">
                                            <div className="contact-icon">
                                                <h4>Connect Us</h4>
                                            </div>
                                        </div>
                                        <div className="single-contact-info">
                                            <div className="contact-icon">Customer Owner Name:</div>
                                            <div className="contact-info-dec">
                                                <p>{partnerData?.Mobile}</p>
                                                <p>{partnerData?.Email}</p>
                                            </div>
                                        </div>
                                        <div className="single-contact-info">
                                            <div className="contact-icon">Sales Person Name:</div>
                                            <div className="contact-info-dec">
                                                <p>{partnerData?.SalesPersonName || "N/A"}</p>
                                            </div>
                                        </div>
                                        <div className="single-contact-info">
                                            <div className="contact-icon">GST Number:</div>
                                            <div className="contact-info-dec">
                                                <p>{partnerData?.GSTNo || "N/A"}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </LayoutTwo>
        </>
    );
};

export default Connect_Us;
